import { render, staticRenderFns } from "./CustomerUnpaidInvoices.vue?vue&type=template&id=6c035a32&scoped=true&"
import script from "./CustomerUnpaidInvoices.vue?vue&type=script&lang=js&"
export * from "./CustomerUnpaidInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c035a32",
  null
  
)

export default component.exports